<div class="row">
    <!-- Total Orders -->
    <div class="col-xxl-3 col-sm-6">
        <div class="order-stat-total trezo-card style-two mb-25 border-radius d-block shadow-none"
             [class.component-dark-theme]="themeService.isDark()"
             [class.component-rtl-enabled]="themeService.isRTLEnabled()">
            <div class="trezo-card-header d-flex align-items-center justify-content-between">
                <div class="trezo-card-title">
                    <h5 class="mb-0 fw-normal text-white">Total Orders</h5>
                </div>
            </div>
            <div class="trezo-card-content bg-white">
                <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0 fw-semibold">{{ dashboardCounter.totalOrders }}</h3>
                    <div class="icon rounded-circle d-flex align-items-center justify-content-center">
                        <i class="material-symbols-outlined">shopping_cart</i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pending Orders -->
    <div class="col-xxl-3 col-sm-6">
        <div class="order-stat-pending trezo-card style-two mb-25 border-radius d-block shadow-none"
             [class.component-dark-theme]="themeService.isDark()"
             [class.component-rtl-enabled]="themeService.isRTLEnabled()">
            <div class="trezo-card-header d-flex align-items-center justify-content-between">
                <div class="trezo-card-title">
                    <h5 class="mb-0 fw-normal text-white">Pending Orders</h5>
                </div>
            </div>
            <div class="trezo-card-content bg-white">
                <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0 fw-semibold">{{ dashboardCounter.totalOrdersPending }}</h3>
                    <div class="icon rounded-circle d-flex align-items-center justify-content-center">
                        <i class="material-symbols-outlined">pending_actions</i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- In Production -->
    <div class="col-xxl-3 col-sm-6">
        <div class="order-stat-production trezo-card style-two mb-25 border-radius d-block shadow-none"
             [class.component-dark-theme]="themeService.isDark()"
             [class.component-rtl-enabled]="themeService.isRTLEnabled()">
            <div class="trezo-card-header d-flex align-items-center justify-content-between">
                <div class="trezo-card-title">
                    <h5 class="mb-0 fw-normal text-white">In Production</h5>
                </div>
            </div>
            <div class="trezo-card-content bg-white">
                <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0 fw-semibold">{{ dashboardCounter.totalOrdersInProduction }}</h3>
                    <div class="icon rounded-circle d-flex align-items-center justify-content-center">
                        <i class="material-symbols-outlined">precision_manufacturing</i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Completed Orders -->
    <div class="col-xxl-3 col-sm-6">
        <div class="order-stat-completed trezo-card style-two mb-25 border-radius d-block shadow-none"
             [class.component-dark-theme]="themeService.isDark()"
             [class.component-rtl-enabled]="themeService.isRTLEnabled()">
            <div class="trezo-card-header d-flex align-items-center justify-content-between">
                <div class="trezo-card-title">
                    <h5 class="mb-0 fw-normal text-white">Completed Orders</h5>
                </div>
            </div>
            <div class="trezo-card-content bg-white">
                <div class="d-flex align-items-center justify-content-between">
                    <h3 class="mb-0 fw-semibold">{{ dashboardCounter.totalOrdersCompleted }}</h3>
                    <div class="icon rounded-circle d-flex align-items-center justify-content-center">
                        <i class="material-symbols-outlined">task_alt</i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
